import React, { useState } from "react";

const copyToClipboard = async (text) => {
    try {
        if (navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(text);
            return true;
        }
    } catch (e) {}
    try {
        const field = document.createElement("textarea");
        field.value = text;
        field.setAttribute("readonly", "");
        field.style.position = "fixed";
        field.style.opacity = "0";
        document.body.appendChild(field);
        field.select();
        const copied = document.execCommand("copy");
        document.body.removeChild(field);
        return copied;
    } catch (e) {
        return false;
    }
};

const DemoRoomModal = ({ open, code, creating, onCreate, onClose }) => {
    const [copied, setCopied] = useState(false);

    if (!open) return null;

    const onCopy = async () => {
        if (!(await copyToClipboard(code))) return;

        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className="confirm-modal-overlay" onClick={onClose}>
            <div
                className="confirm-modal-container"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="confirm-modal-title">Sala temporal</div>
                <div className="confirm-modal-message">
                    Se creará una sala de prueba que cualquiera puede usar y que se borrará automáticamente a los 30 minutos.
                    Comparte y usa este código para entrar a la sala:
                </div>

                <div className="demo-code-row">
                    <input
                        className="demo-code-field"
                        type="text"
                        value={code}
                        readOnly
                        onFocus={(e) => e.target.select()}
                        aria-label="Código de la sala"
                    />
                    <button
                        type="button"
                        className="demo-code-copy"
                        onClick={onCopy}
                        title="Copiar al portapapeles"
                    >
                        {copied ? "¡Copiado!" : "Copiar"}
                    </button>
                </div>

                <div className="confirm-modal-actions">
                    <button
                        className="confirm-modal-btn-cancel"
                        onClick={onClose}
                        disabled={creating}
                    >
                        Salir
                    </button>
                    <button
                        className="confirm-modal-btn-confirm"
                        onClick={onCreate}
                        disabled={creating}
                    >
                        {creating ? "Creando…" : "Crear"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DemoRoomModal;
